import { Stack } from "@fluentui/react/lib/Stack";

import { Grid } from "./Grid";
import { Center } from "../Generic/Center";
import { Search } from "./Search";
import { useOverviewStyles } from "./UseOverviewStyles";
import { Toolbar } from "../Toolbar";

export function Overview(): JSX.Element {
  const styles = useOverviewStyles();
  return (
    <Center>
      <Stack grow className={styles.root}>
        <Stack grow={false} disableShrink={false} className={styles.gridHeaderBar}>
          <Stack.Item>
            <Search />
          </Stack.Item>
          <Stack horizontal horizontalAlign="end">
            <Toolbar />
          </Stack>
        </Stack>
        <Stack.Item grow disableShrink={false}>
          <Grid />
        </Stack.Item>
      </Stack>
    </Center>
  );
}
